import React, { FC } from 'react';
import { Container } from './styles';
import { Doughnuts } from './components';
import DashboardHeader from '../../components/dashboard-header';
import { useAuth } from '../../context/user.context';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../context/navigationContext';
import { useAnalyticsAccess } from '../../api/analyticsAccess';

interface User {
  first_name: string;
  email: string;
}

interface AuthContext {
  user: { user: User };
}

const HomePage: FC = () => {
  const { user } = useAuth() as AuthContext;
  const [t] = useTranslation();
  const canSeeDashboard = useAnalyticsAccess().state === 'allowed';
  usePageTitle(t("PAGE_TITLE_HOME"));

  return (
    <Container>
      <DashboardHeader
        analyticsAvailable={canSeeDashboard}
        greeting={`${t('WELCOME')} ${user.user.first_name}!`}
      />
      <Doughnuts/>
    </Container>
  );
};

export default HomePage;
